// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fixed-width[data-v-19b41af0]{width:66px}@media screen and (max-width:768px){.mobile-fixed-width[data-v-19b41af0]{width:240px}}.fixed-height[data-v-19b41af0]{height:22px}.height-70px[data-v-19b41af0]{height:70px}.line-height-1[data-v-19b41af0]{line-height:1}.gap-10px[data-v-19b41af0]{gap:10px}.gap[data-v-19b41af0]{gap:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
